import type {
  SortableUserColumn,
  UserLastLoginFilter,
  UserList,
  UserRole,
  UsersListResponse,
  UserSortDirection,
  UserStatus,
} from '@app/application/user-management/types'

import SFetch from '@app/utils/sfetch'
import { getSignal } from '@app/adapters/abort'
import { USERS_REQUEST_KEY } from '@app/application/user-management/constants'

export const fetchUsers = ({
  list,
  page = 1,
  sortBy,
  sortDirection,
  search,
  role,
  status,
  lastLogin,
}: {
  list: UserList
  page?: number
  sortBy?: SortableUserColumn
  sortDirection?: UserSortDirection
  search?: string
  role?: UserRole
  status?: UserStatus
  lastLogin?: UserLastLoginFilter
}): Promise<UsersListResponse | null> => {
  const route =
    list === 'staff'
      ? window.Silverfin.Routes.staff_users_path
      : window.Silverfin.Routes.external_users_path

  return SFetch.json<UsersListResponse>(
    route(window.Silverfin.currentFirmId, {
      format: 'json',
      page,
      sort_by: sortBy,
      sort_direction: sortDirection,
      q: search,
      role,
      status,
      last_login: lastLogin,
    }),
    { signal: getSignal(USERS_REQUEST_KEY) }
  )
}
